import React, { useRef, useState } from 'react';
import { renderIcon } from '../../../SprintDetail/FlowchartView/utils/renderIcon';
import IconPicker from '../../../SprintDetail/shared/IconPicker';

/**
 * Icon + title stay mounted while the body is a skeleton so chrome cannot
 * shift when the editor swaps in.
 */
const LibraryDocChrome = ({
  doc,
  chromeIcon,
  chromeTitle,
  showSaveState,
  saveLabel,
  saveState,
  onTitleChange,
  onTitleKeyDown,
  onIconChange,
}) => {
  const iconBtnRef = useRef(null);
  const [showIconPicker, setShowIconPicker] = useState(false);
  const [iconPickerPosition, setIconPickerPosition] = useState(null);

  const handleIconClick = () => {
    const btn = iconBtnRef.current;
    if (!btn) return;
    const r = btn.getBoundingClientRect();
    setIconPickerPosition({ x: r.left, y: r.bottom + 6 });
    setShowIconPicker(true);
  };

  return (
    <>
      {showSaveState && doc && (
        <span className={`library-doc-pane__save-state ${saveState === 'error' ? 'is-error' : ''}`}>
          {saveLabel}
        </span>
      )}
      <button
        ref={iconBtnRef}
        type="button"
        className="library-doc-pane__doc-icon library-doc-pane__doc-icon--editable"
        onClick={doc ? handleIconClick : undefined}
        disabled={!doc}
        title="Change icon"
      >
        {chromeIcon != null ? (
          renderIcon(chromeIcon, { size: '40px', fallback: <span>📄</span> })
        ) : (
          <span className="library-doc-pane__doc-icon-ph" aria-hidden="true" />
        )}
      </button>
      {showIconPicker && doc && (
        <IconPicker
          currentIcon={doc.icon}
          onIconChange={onIconChange}
          onIconDeleted={() => onIconChange(null)}
          onClose={() => setShowIconPicker(false)}
          position={iconPickerPosition}
        />
      )}
      <input
        className="library-doc-pane__title-input"
        value={chromeTitle}
        onChange={doc ? onTitleChange : undefined}
        onKeyDown={doc ? onTitleKeyDown : undefined}
        readOnly={!doc}
        placeholder="Untitled Doc"
        aria-label="Doc title"
      />
    </>
  );
};

export default LibraryDocChrome;
